import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin, } from 'react-icons/fa';
import { IconSocialMedia } from './IconSocialMedia';

export const Socials = () => {
  return (
    <div className='flex gap-x-[10px]'>
      <IconSocialMedia title='Instagram' link='https://www.instagram.com/yank.a.s.12/' icon={<FaInstagram />} />
      <IconSocialMedia title='Whatsapp' link='https://wa.me/5547999556723' icon={<FaWhatsapp />} />
      <IconSocialMedia title='Facebook' link='https://www.facebook.com/yankaikyaugusto.dossantos/' icon={<FaFacebook />} />
      <IconSocialMedia title='Linkedin' link='https://www.linkedin.com/in/yankaiky/' icon={<FaLinkedin />} />
    </div>
  );
};
